import _ from "lodash"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"

import Client from "data/_client"
import { ApiResult } from "data/interface/api"
import notificationService from "data/notification"
// private module logic //

export type AuditLog_t = {
  change: string // json
  correlationid?: string // uuid
  created: Date
  folderid?: number
  folderpath?: string
  historyid: number
  method: 'POST' | 'PATCH' | 'DELETE' | 'MARK'
  organizationid?: string //uuid  // ! shouldn't be nullable, but a few thousand such old rows exist in dev
  propertycode?: string
  propertyid?: number
  resource: string
  resourcecode?: string
  resourceid?: number
  user: {
    id: string // uuid
    name: string
    email: string
  } | {
    service
  } | { }
}

const id: string = "audit-log"
const initialState: ApiResult<AuditLog_t[]> = { id, state: "init", value: [] }
const auditLogStream = new BehaviorSubject<ApiResult<AuditLog_t[]>>(initialState)

function fetch(
  resources: string[],
  filters?: string[]
): Promise<AuditLog_t[] | { message: string }> {
  auditLogStream.next({ id, state: 'busy', value: auditLogStream.getValue().value })

  let url = `history?limit=500&order=created.desc`
  if (resources.length) url += `&resource=in.${resources.join(',')}`
  if (filters  && filters.length) url += '&' + filters.join('&')

  return Client.get(url)
  .then((records: AuditLog_t[]) => {
    auditLogStream.next({ id, state: 'ok', value: records })
    return records
  })
  .catch((err: { message: string }) => {
    notificationService.notify({ type: 'danger', message: err.message, dismiss: 5000 })
    return err
  })
}

// public module interface //

const auditLogService = {
  stream: () => auditLogStream.asObservable(),
  value: () => auditLogStream.getValue().value,
  fetch,
}

export default auditLogService

